import {PageTitle} from '../../../../_designereyes/layout/core'
import {AmazonHelium10RawUploaderPage} from './AmazonHelium10RawUploaderPage'

const breadcrumbs = [
  {
    title: 'Home',
    path: '/',
    isSeparator: false,
    isActive: false,
  },
  {
    title: ' / ',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const AmazonHelium10RawUploader = () => {
  return (
    <>
      <PageTitle breadcrumbs={breadcrumbs}>Helium 10 Raw Data Uploader</PageTitle>
      <AmazonHelium10RawUploaderPage />
    </>
  )
}

export default AmazonHelium10RawUploader
